












































































































































































































































































































































































































































































import Http from "@/mixins/http";
import LocalData from "@/mixins/local-data";
import Toast from "@/mixins/toast";
import {Component, Mixins, Prop} from "vue-property-decorator";
import Card from "../UI/Card.vue";
import {
    AuditParams, FetchResultsFilterParams,
    IdAndName,
    ParsingResultsTableFilterValues,
    ParsingResultsTableOptions,
    ParsingResultTableItem,
    SortingFieldNames,
} from "@/interfaces/server-data";
import moment from "moment";
import { isValidNumberValue } from "@/utils/utils";
import {isBoolean} from "lodash";

interface FilterItem {
  id: number;
  text: string;
  value: number;
  isSelected: boolean;
}

interface TheMarket {
  id: number;
  tradingName: string;
  isDefault: boolean;
  editable: boolean;
}

interface CombinedFilters {
  groups: FilterItem[];
  categories: FilterItem[];
  subcategories: FilterItem[];
  storeFormat: FilterItem[];
  storeRegion: FilterItem[];
  storeCluster: FilterItem[];
}

@Component({
  components: {
    Card,
  },
  computed: {
      isValidNumberValue() {
          return isValidNumberValue;
      }
  },
})
export default class ParsingResults extends Mixins(LocalData, Toast, Http) {
  @Prop({required: true}) theFilters!: CombinedFilters;
  @Prop({
    required: true,
    default: {id: 0, tradingName: "", isDefault: false, editable: true},
  })
  theMarket!: TheMarket;

  dateRangeFilter: any = [];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
  }
  sortingData: any = {
    field: 'parsedAt',
    order: 'desc',
  }
  sortingFieldNames: SortingFieldNames = {
      fileName: 'file.filePath',
      auditStatus: 'deviationLimitsExceeded',
  };

  auditPollingInterval: number | null = null;

  isAuditRunning: boolean = true;
  isParsingResultsTableLoading: boolean = false;

  parsingResultsTableData: ParsingResultTableItem[] = [];

  parsingResultsTableOptions: ParsingResultsTableOptions = {
      competitorCode: [],
      competitorName: [],
      file: [],
      internalCode: [],
      promoPrice: [],
      regularPrice: [],
      skuName: [],
      storeCluster: [],
      storeFormat: [],
      storeRegion: [],
      auditStatus: [],
  };

  parsingResultsTableFilterValues: ParsingResultsTableFilterValues = {
    internalCodeList: [],
    skuNameContainsList: [],
    competitorCodeList: [],
    competitorNameContainsList: [],
    regularPrice: [],
    promoPrices: [],
    storeFormatIdList: [],
    storeRegionIdList: [],
    storeClusterIdList: [],
    marketMedianDeviationRange: { min: null, max: null },
    competitorMovingAvgDeviationRange: { min: null, max: null },
    auditStatusList: [],
    fileList: [],
  };

  isCommonCheckboxSelected: boolean = false;
  includedIds: number[] = [];
  excludedIds: number[] = [];

  monitoringFile: File | null = null;
  errorsAmount: number = 0;

  showAuditModal: boolean = false;
  isStartAuditBtnLoading: boolean = false;

  auditParams: AuditParams = {
    marketMedianDeviation: 10,
    competitorSlidingAverageDeviation: 10,
    searchDepth: 30,
  };

  isDeleteParsingResultsBtnLoading: boolean = false;

  parsingResultsTableColumns: any[] = [
    {
      key: 'checkboxes',
      scopedSlots: {
        title: 'commonCheckbox',
        customRender: 'rowCheckbox',
      },
      width: 15,
    },
    {
      dataIndex: "internalCode",
      title: this.$t('shared.table.internalCode') as string,
      filterOptionsKey: 'internalCode',
      filterModelKey: 'internalCodeList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      sorter: true,
      width: 170,
    },
    {
      dataIndex: "skuName",
      title: "SKU",
      filterOptionsKey: 'skuName',
      filterModelKey: 'skuNameContainsList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      sorter: true,
      width: 150,
      ellipsis: true,
    },
    {
      dataIndex: "storeFormat.name",
      title: this.$t('shared.table.format') as string,
      width: 100,
      filterOptionsKey: 'storeFormat',
      filterModelKey: 'storeFormatIdList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      sorter: true,
    },
    {
      dataIndex: "storeRegion.name",
      title: this.$t('shared.table.region') as string,
      width: 100,
      filterOptionsKey: 'storeRegion',
      filterModelKey: 'storeRegionIdList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      sorter: true,
    },
    {
      dataIndex: "storeCluster.name",
      title: this.$t('shared.table.cluster') as string,
      width: 70,
      filterOptionsKey: 'storeCluster',
      filterModelKey: 'storeClusterIdList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      sorter: true,
    },
    {
      key: "competitorCode",
      dataIndex: "competitorCode",
      title: this.$t('shared.table.competitorCode') as string,
      filterOptionsKey: 'competitorCode',
      filterModelKey: 'competitorCodeList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      width: 140,
      sorter: true,
    },
    {
      dataIndex: "parsingUrl",
      title: this.$t('shared.table.competitorSite') as string,
      width: 400,
    },
    {
      dataIndex: "competitorName",
      title: this.$t('shared.table.competitorName') as string,
      filterOptionsKey: 'competitorName',
      filterModelKey: 'competitorNameContainsList',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      ellipsis: true,
      width: 180,
      sorter: true,
    },
    {
      dataIndex: "fileName",
      title: this.$t('shared.table.fileName') as string,
      filterOptionsKey: 'file',
      filterModelKey: 'fileList',
      scopedSlots: {
          filterDropdown: 'fileFilterMulti',
          filterIcon: 'filterIcon',
      },
      ellipsis: true,
      sorter: true,
      width: 400,
    },
    {
      dataIndex: "parsedAt",
      title: this.$t('priceMonitoring.parsingResults.lastParsingDateTime') as string,
      width: 300,
      scopedSlots: {
        customRender: "parsedAt",
        filterDropdown: 'filterRangePicker',
        filterIcon: "filterIcon",
      },
      ellipsis: true,
      sorter: true,
    },
    {
      dataIndex: "regularPrice",
      title: this.$t('shared.table.regularPrice') as string,
      filterOptionsKey: 'regularPrice',
      filterModelKey: 'regularPrice',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      width: 100,
      ellipsis: true,
      sorter: true,
    },
    {
      dataIndex: "promoPrice",
      title: this.$t('shared.table.promoPrice') as string,
      filterOptionsKey: 'promoPrice',
      filterModelKey: 'promoPrices',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      width: 100,
      ellipsis: true,
      sorter: true,
    },
    {
      dataIndex: "marketMedianDeviation",
      title: this.$t('priceMonitoring.parsingResults.marketMedianDeviationCol') as string,
      width: 220,
      scopedSlots: {
        customRender: 'marketMedianDeviation',
        filterDropdown: 'filterRangeDropdown',
        filterIcon: 'filterIcon',
      },
      filterModelKey: 'marketMedianDeviationRange',
      sorter: true,
    },
    {
      dataIndex: 'competitorSlidingAverageDeviation',
      title: this.$t('priceMonitoring.parsingResults.competitorSlidingAvgCol') as string,
      width: 250,
      scopedSlots: {
        customRender: 'competitorSlidingAverageDeviation',
        filterDropdown: 'filterRangeDropdown',
        filterIcon: 'filterIcon',
      },
      filterModelKey: 'competitorMovingAvgDeviationRange',
      sorter: true,
    },
    {
      dataIndex: 'auditStatus',
      title: this.$t('priceMonitoring.parsingResults.auditStatus') as string,
      width: 180,
      filterOptionsKey: 'auditStatus',
      filterModelKey: 'auditStatusList',
      scopedSlots: {
        customRender: 'auditStatus',
        filterDropdown: 'filterCheckboxes',
        filterIcon: 'filterIcon',
      },
      sorter: true,
    },
  ];

  mounted() {
    this.fetchParsingResultsData();
    this.fetchParsingResultsTableOptions();
    this.getErrorsAmount();
    this.fetchAuditStatus();
  }

  copyToClipboard(text: string) {
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }

  async fetchParsingResultsData(currentPage?: number) {
    if (currentPage) {
      this.pagination.current = currentPage;
    }

    const filter = this.prepareFilterObjectForFetchingResults()

    this.isParsingResultsTableLoading = true;

    this.httpFetchParsingResults(filter, {
      params: {
        page: this.pagination.current - 1,
        size: this.pagination.pageSize,
        sortBy: this.sortingData.field,
        sortDirection: this.sortingData.order,
      }
    }).then((response) => {
      this.parsingResultsTableData = response.data.content.map(el => ({...el, auditStatus: el.auditResult }));

      this.pagination.total = response.data.totalElements;
    }).catch(() => {
      this.parsingResultsTableData = [];
    }).finally(() => {
      this.isParsingResultsTableLoading = false;
    });
  }

  prepareFilterObjectForFetchingResults(): FetchResultsFilterParams {
    return {
      tradingId: this.theMarket.id,
      parsedFrom: this.dateRangeFilter[0] ? this.dateRangeFilter[0] : null,
      parsedTo: this.dateRangeFilter[1] ? this.dateRangeFilter[1] : null,
      competitorCodeList: this.parsingResultsTableFilterValues.competitorCodeList,
      competitorNameContainsList: this.parsingResultsTableFilterValues.competitorNameContainsList,
      internalCodeList: this.parsingResultsTableFilterValues.internalCodeList,
      skuNameContainsList: this.parsingResultsTableFilterValues.skuNameContainsList,
      promoPrices: this.parsingResultsTableFilterValues.promoPrices,
      regularPrice: this.parsingResultsTableFilterValues.regularPrice,
      marketMedianDeviationMin: this.parsingResultsTableFilterValues.marketMedianDeviationRange.min,
      marketMedianDeviationMax: this.parsingResultsTableFilterValues.marketMedianDeviationRange.max,
      competitorSlidingAverageDeviationMin: this.parsingResultsTableFilterValues.competitorMovingAvgDeviationRange.min,
      competitorSlidingAverageDeviationMax: this.parsingResultsTableFilterValues.competitorMovingAvgDeviationRange.max,
      auditResults: this.parsingResultsTableFilterValues.auditStatusList,
      fileIds: this.parsingResultsTableFilterValues.fileList,
    }
  }

  fetchParsingResultsTableOptions() {
    this.httpFetchParsingResultsTableOptions(this.theMarket.id)
        .then((r) => {
              this.parsingResultsTableOptions = r.data.fields;
            },
        );
  }

  fetchAuditStatus(isPollingInitiator: boolean = false) {
      this.httpGetAuditProcessStatus(this.theMarket.id).then((r) => {
          if (r.data === 'IN_PROGRESS') {
              if (!isPollingInitiator) {
                  this.startAuditPolling();
              }
          } else {
              this.stopAuditPolling();

              if (isPollingInitiator) {
                  if (r.data === 'DONE') {
                      this.showInfo(this.$t('priceMonitoring.parsingResults.auditCompletedSuccess') as string, 6);
                  } else if (r.data === 'FAILED') {
                      this.showError(this.$t('priceMonitoring.parsingResults.auditCompletedError') as string);
                  }
              }
          }
      }).catch(() => {
          this.stopAuditPolling();
      });
  }

  getSortingFieldName(field: keyof SortingFieldNames): string {
      return this.sortingFieldNames[field] || field;
  }

  onResultTableChange(pagination: any, filters: any, sorter: any) {
    this.pagination.current = pagination.current;

    if (sorter.field && sorter.order) {
      this.sortingData = {
        field: this.getSortingFieldName(sorter.field),
        order: sorter.order === 'descend' ? 'desc' : 'asc',
      }
    } else {
      this.sortingData = {
        field: 'parsedAt',
        order: 'desc',
      }
    }

    this.fetchParsingResultsData();
  }

  handleApplyParsingResultsBtnClick() {
    this.httpApplyParsingResults({
      filter: this.prepareFilterObjectForFetchingResults(),
      selectCheckboxesData: {
        isCommonCheckboxSelected: this.isCommonCheckboxSelected,
        includedIds: this.includedIds,
        excludedIds: this.excludedIds,
      },
    }).then(() => {
      this.showInfo(this.$t('priceMonitoring.parsingResults.parsingResultsApplied') as string);

      this.fetchParsingResultsData();

      this.resetIncludedAndExcludedCheckboxes();
      this.isCommonCheckboxSelected = false;
    });
  }

  isRowCheckboxChecked(id: number) {
    if (this.isCommonCheckboxSelected) {
      return !this.excludedIds.includes(id);
    } else {
      return this.includedIds.findIndex(includedId => includedId === id) > -1;
    }
  }

  handleRowCheckboxClicked(item: any, value: boolean) {
    if (this.isCommonCheckboxSelected) {
      if (value) {
        const index = this.excludedIds.findIndex(id => id === item.id);

        if (index > -1) this.excludedIds.splice(index, 1);
      } else {
        this.excludedIds.push(item.id);
      }
    } else {
      if (value) {
        this.includedIds.push(item.id);
      } else {
        const index = this.includedIds.findIndex(id => id === item.id);

        if (index > -1) this.includedIds.splice(index, 1);
      }
    }
  }

  resetIncludedAndExcludedCheckboxes() {
    this.includedIds = [];
    this.excludedIds = [];
  }

  get selectedProductsCount(): number {
    if (this.isCommonCheckboxSelected) {
      return this.pagination.total - this.excludedIds.length;
    } else {
      return this.includedIds.length;
    }
  }

  getFilterOptions(filterOptionsKey: keyof ParsingResultsTableOptions) {
      const options: any[] = [];

      if (filterOptionsKey === 'auditStatus') {
          Object.assign(options, [
              { label: this.$t('priceMonitoring.parsingResults.acceptableDeviations') as string, value: 'ACCEPTABLE' },
              { label: this.$t('priceMonitoring.parsingResults.unacceptableDeviations') as string, value: 'UNACCEPTABLE' },
          ]);
      } else {
          Object.assign(
              options,
              (this.parsingResultsTableOptions[filterOptionsKey] as (string | number)[])
                  .map((el: string | number | IdAndName) => (
                      {
                          label: typeof el === 'object' ? el.name : String(el),
                          value: typeof el === 'object' ? el.id : el,
                      }
                    ))
          );
      }

      if (['auditStatus', 'file'].includes(filterOptionsKey)) {
          options.unshift({ label: this.$t('priceMonitoring.parsingResults.noValueEmpty') as string, value: 'EMPTY_VALUE' });
      }

      return options;
  }

  downloadParsingResultsFile() {
    if (!this.theMarket) {
      this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
      return;
    }

    const filter = this.prepareFilterObjectForFetchingResults()

    this.isParsingResultsTableLoading = true
    this.httpGetParsingResultsFile(filter)
        .then((response) => {
          let extension = '.csv'
          let dateString = moment().format('YYYYMMDD_HHmmss')
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
              'download',
              (this.$t('priceMonitoring.parsingResults.exportFileName') as string) + '_' + this.theMarket!!.tradingName + '_' + dateString + extension
          );

          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.isParsingResultsTableLoading = false
        })
  }

  handleStartAudit() {
      this.isStartAuditBtnLoading = true;

      this.httpStartPriceAudit({
          filter: this.prepareFilterObjectForFetchingResults(),
          selectCheckboxesData: {
              isCommonCheckboxSelected: this.isCommonCheckboxSelected,
              includedIds: this.includedIds,
              excludedIds: this.excludedIds,
          },
          marketMedianDeviationPercentCap: this.auditParams.marketMedianDeviation,
          competitorSlidingAverageDeviationPercentCap: this.auditParams.competitorSlidingAverageDeviation,
          auditDepthInDays: this.auditParams.searchDepth,
      }).then(() => {
          this.showInfo(this.$t('priceMonitoring.parsingResults.auditStartedSuccess') as string);

          this.showAuditModal = false;

          this.startAuditPolling();

          this.fetchParsingResultsData();
          this.fetchParsingResultsTableOptions();
      }).catch(() => {
          this.showError(this.$t('priceMonitoring.parsingResults.errorStartAudit') as string);
      }).finally(() => {
          this.isStartAuditBtnLoading = false;
      });
  }

  handleDeleteParsingResultsBtnClick() {
      this.$confirm({
          title: this.$t('priceMonitoring.parsingResults.deleteResultsTitle') as string,
          content: this.$t('priceMonitoring.parsingResults.deleteResultsContent') as string,
          okText: this.$t('priceMonitoring.parsingResults.yesDelete') as string,
          okType: 'danger',
          cancelText: this.$t('shared.actions.cancel') as string,
          onOk: () => {
              this.isDeleteParsingResultsBtnLoading = true;

              this.httpDeleteParsingResults({
                  filter: this.prepareFilterObjectForFetchingResults(),
                  selectCheckboxesData: {
                    isCommonCheckboxSelected: this.isCommonCheckboxSelected,
                    includedIds: this.includedIds,
                    excludedIds: this.excludedIds,
                  },
              }).then(() => {
                  this.showInfo(this.$t('priceMonitoring.parsingResults.parsingResultsDeleted') as string);

                  this.fetchParsingResultsData();
                  this.fetchParsingResultsTableOptions();

                  this.resetIncludedAndExcludedCheckboxes();
                  this.isCommonCheckboxSelected = false;
              }).finally(() => {
                  this.isDeleteParsingResultsBtnLoading = false;
              });
          },
      });
  }

  formatPercentage(value: number): string {
      return `${value.toFixed(2)}%`;
  }

  getDeviationClass(value?: boolean): string {
      if (isBoolean(value)) {
          return value ? 'deviation-unacceptable' : 'deviation-acceptable';
      } else {
          return '';
      }
  }

  badgeStyle(errorsAmount: number | null) {
      return {
          backgroundColor: 'white',
          size: '10px',
          color: !!errorsAmount ? 'red' : 'gray',
          borderColor: !!errorsAmount ? 'red' : 'gray',
      }
  }

  get disableUploadButtons(): boolean {
      return !this.monitoringFile || this.isParsingResultsTableLoading || this.isDeleteParsingResultsBtnLoading;
  }

  get disableFileInput(): boolean {
      return this.isParsingResultsTableLoading;
  }

  uploadMonitoringFile() {
      if (!this.monitoringFile) {
          this.showError(this.$t('shared.messages.selectFile') as string);
          return;
      }

      if (!this.theMarket) {
          this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
          return;
      }

      const uploadFile = new FormData();

      uploadFile.append(
          'file',
          new Blob([this.monitoringFile]),
          this.monitoringFile.name
      );

      this.isParsingResultsTableLoading = true;

      this.httpUploadMonitoringFile(this.theMarket.id, uploadFile)
          .then((r) => {
              this.showInfo(r.data ? r.data : this.$t('shared.messages.fileUploadedSuccess') as string);

              this.monitoringFile = null;
          })
          .catch((e) => {
              this.showError(this.$t('shared.messages.errorUploadFile') as string);

              this.monitoringFile = null;
          })
          .finally(() => {
              this.isParsingResultsTableLoading = false;

              this.fetchParsingResultsData();
              this.fetchParsingResultsTableOptions();
              this.getErrorsAmount();
          });
  }

  getErrorsAmount() {
      if (!this.theMarket) {
          return;
      }

      this.httpGetMonitoringErrorsAmount(this.theMarket.id)
          .then((r) => {
              this.errorsAmount = r.data;
          });
  }

  downloadErrors() {
      if (!this.theMarket) {
          this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
          return;
      }

      this.isParsingResultsTableLoading = true;

      this.httpGetMonitoringErrors(this.theMarket.id)
          .then((response) => {
              if (!response.data.size) {
                  this.showInfo(this.$t('shared.messages.noErrors') as string)
                  return;
              }

              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.$t('priceMonitoring.parsingResults.errorsDownloadFileName') as string);

              document.body.appendChild(link);
              link.click();
          })
          .finally(() => {
              this.isParsingResultsTableLoading = false;
          });
  }

  fileNameSearchFilterOption(input: string, option: any) {
      return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
  }

  stopAuditPolling() {
      if (this.auditPollingInterval !== null) {
          clearInterval(this.auditPollingInterval);

          this.auditPollingInterval = null;
      }

      this.isAuditRunning = false;

      this.fetchParsingResultsData();
  }

  startAuditPolling() {
      this.isAuditRunning = true;

      this.auditPollingInterval = setInterval(() => {
          this.fetchAuditStatus(true);
      }, 4000);
  }
}
